import { Connector } from '@web3-wallet/core';
import { icon } from './assets';
const providerFilter = (p) => !!p.isTrust;
const _walletName = 'Trust Wallet';
const walletName = _walletName;
export class TrustWallet extends Connector {
    /** {@inheritdoc Connector.constructor} */
    constructor(options) {
        super({
            providerFilter,
            ...options,
        });
        this.walletName = walletName;
    }
}
TrustWallet.walletName = walletName;
TrustWallet.walletIcon = icon;
